import { getDataDogApplicationId, getDataDogClientToken, getEnvironment, getDatadogServiceName, getVersionName } from 'utils/config-environment';
import { datadogRum } from '@datadog/browser-rum'

export const loadMonitoringApplications = () => {
  loadDataDogRum();
}

const loadDataDogRum = () => {
  if (!(getDataDogApplicationId() && getDataDogClientToken()))
    return;

  datadogRum.init({
    applicationId: getDataDogApplicationId(),
    clientToken: getDataDogClientToken(),
    site: 'datadoghq.com',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    trackFrustrations: true,
    defaultPrivacyLevel: 'mask-user-input',
    service: getDatadogServiceName(),
    env: getEnvironment(),
    version: getVersionName()
  });

  datadogRum.startSessionReplayRecording();
}